import React from 'react';
import { XCircle } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const CancellationConfirmationModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showCancellationConfirmation}
      onClose={() => app.setShowCancellationConfirmation(false)}
      size="sm"
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper modal__icon-wrapper--info">
          <XCircle size={28} />
        </div>
        <h2 className="modal__title">Subscription Cancelled</h2>
        <p className="modal__subtitle">
          Your subscription has been cancelled. You can resubscribe anytime to regain access.
        </p>
      </div>
      <div className="modal__body">
        <button
          className="btn btn-secondary btn-full"
          onClick={() => app.setShowCancellationConfirmation(false)}
        >
          Got It
        </button>
      </div>
    </Modal>
  );
};

export default CancellationConfirmationModal;
